import { QueryFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export type PriorToDefinition = {
  name: string;
};

const _mockPriorToDefinitionsByTypeId: Record<string, PriorToDefinition[]> = {
  'investor-delivery': [
    { name: 'Funding' },
    { name: 'Approval' },
    { name: 'Closing' },
    { name: 'Purchase' },
    { name: 'Docs' },
  ],
  preliminary: [{ name: 'Approval' }, { name: 'Docs' }],
  underwriting: [{ name: 'Approval' }, { name: 'Funding' }],
  'post-closing': [{ name: 'Closing' }],
  closing: [{ name: 'Closing' }, { name: 'Purchase' }],
};

const getPriorToDefinitions: QueryFunction<
  PriorToDefinition[],
  ['/encompass/condition-types/prior-to-definitions', string]
> = async ({ queryKey }) => {
  const typeId = queryKey[1];
  if (!typeId) return [];

  if (isMockServices()) {
    return await mock(_mockPriorToDefinitionsByTypeId[typeId] ?? []);
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<PriorToDefinition[]>(
    `/encompass/condition-types/${encodeURIComponent(typeId)}/prior-to-definitions`,
    {
      method: 'GET',
    },
  );

  return response.data ?? [];
};

export default getPriorToDefinitions;
